import { queryOptions } from "@tanstack/react-query";

import { api } from "@/api/api";
import type {
  GetFlightUpsellBodyInputDto,
  GetFlightUpsellOutputDto,
} from "@/types/codegen";

type FlightUpsellParams = {
  index: string;
  body: GetFlightUpsellBodyInputDto;
  onSuccess?: (data: GetFlightUpsellOutputDto["data"]) => void;
};

export const flightUpsellQueryOptions = ({
  onSuccess,
  ...params
}: FlightUpsellParams) =>
  queryOptions({
    queryKey: ["flight-upsell", params] as const,
    queryFn: async ({ signal }) => {
      const data = await api.post<GetFlightUpsellOutputDto>(
        `/flights/${params.index}/upsell`,
        params.body,
        { signal },
      );

      onSuccess?.(data.data.data);

      return data;
    },
    select: (data) => data.data.data,
  });
